/*
Copyright (c) 2015, salesforce.com, inc. All rights reserved.

Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
Neither the name of salesforce.com, inc. nor the names of its contributors may be used to endorse or promote products derived from this software without specific prior written permission.

THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
*/

import { GET_RECENT_JOURNEYS_EDITED } from '../constants';

function cleanData(journeys) {
  if (journeys) {
    return journeys
      .map(({ id, key, name, description, modifiedDate, status, version }) => ({
        id,
        key,
        name,
        description,
        modifiedDate: Date.parse(modifiedDate),
        status,
        version,
      }))
      .slice(0, 5);
  }

  return journeys;
}

let exampleState = [];
if (process.env.NODE_ENV !== 'production') {
  exampleState = cleanData([
    {
      id: '72554d37-1e3d-4e18-844d-91e3ef46e01b',
      key: 'fbff0cc5-972c-3ad4-da4a-d26492386388',
      name: 'WelcomeSeries_CAN',
      lastPublishedDate: '2016-04-15T17:02:00Z',
      description: '',
      version: 8,
      workflowApiVersion: 1.0,
      createdDate: '2016-04-15T16:08:20Z',
      modifiedDate: '2016-05-23T22:18:33Z',
      goals: [],
      stats: {
        currentPopulation: 13626,
        cumulativePopulation: 6813,
        metGoal: 0,
        goalPerformance: 0.0,
      },
      entryMode: 'SingleEntryAcrossAllVersions',
      defaults: {
        email: ['{{Contact.Default.Email}}'],
      },
      executionMode: 'Production',
      status: 'Stopped',
      definitionId: '92c1bc88-7909-4ab3-883b-dd0dfae04e27',
    },
  ]);
}

export default function recentJourneysEdited(state = exampleState, action) {
  switch (action.type) {
    case GET_RECENT_JOURNEYS_EDITED: {
      let newState = state;

      if (action.error) {
        newState = [...state];
        newState.error = action.error;
      } else if (action.payload.response && action.payload.response.items) {
        newState = cleanData(action.payload.response.items);
      }

      return newState;
    }
    default: {
      return state;
    }
  }
}
